import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getBusinessProcessBaseExecutors(companyId, businessProcessId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].getBusinessProcessBaseExecutors, {
		urlParams: {
			companyId,
            businessProcessId
		},
	})
}

function getBusinessProcessBaseExecutorPopup(companyId, businessProcessId, baseExecutorId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].getBusinessProcessBaseExecutorPopup, {
		urlParams: {
			companyId,
			businessProcessId,
            baseExecutorId,
		},
	})
}

function getBusinessProcessBaseExecutorPreview(companyId, businessProcessId, baseExecutorId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].getBusinessProcessBaseExecutorPreview, {
		urlParams: {
			companyId,
			businessProcessId,
            baseExecutorId
		},
	})
}

function getBusinessProcessBaseExecutor(companyId, businessProcessId, baseExecutorId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].getBusinessProcessBaseExecutor, {
		urlParams: {
			companyId,
			businessProcessId,
            baseExecutorId,
		},
	})
}

function createBusinessProcessBaseExecutor(companyId, businessProcessId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].createBusinessProcessBaseExecutor, {
		urlParams: {
			companyId,
            businessProcessId,
		},
		...data,
	})
}


function patchBusinessProcessBaseExecutor(companyId, businessProcessId, baseExecutorId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].patchBusinessProcessBaseExecutor, {
		urlParams: {
			companyId,
			businessProcessId,
            baseExecutorId
		},
		...data,
	})
}

function putBusinessProcessBaseExecutor(companyId, businessProcessId, baseExecutorId, data) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].putBusinessProcessBaseExecutor, {
		urlParams: {
			companyId,
			businessProcessId,
            baseExecutorId,
		},
		...data,
	})
}

function deleteBusinessProcessBaseExecutor(companyId, businessProcessId, baseExecutorId) {
	return dataTransferWrap(ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS, dtConfig[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].deleteBusinessProcessBaseExecutor, {
		urlParams: {
			companyId,
			businessProcessId,
            baseExecutorId,
		},
	})
}

export default {
	getBusinessProcessBaseExecutors,
	getBusinessProcessBaseExecutorPopup,
	getBusinessProcessBaseExecutorPreview,
	getBusinessProcessBaseExecutor,
	createBusinessProcessBaseExecutor,
	patchBusinessProcessBaseExecutor,
	putBusinessProcessBaseExecutor,
	deleteBusinessProcessBaseExecutor,
}
